module.exports = __webpack_public_path__ + "img/calendar.15fef0ad.svg";